<template>
  <div>
    <div class="vx-col w-full mb-base">
      <vx-card :title="PopupTitle ? PopupTitle : 'Clone project'">
        <div v-if="!isClonning">
          <div class="vx-row mb-6" v-if="ProjectOnly">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Title:</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input class="w-full" v-model="newGitInfo.Title" />
            </div>
          </div>
          <div class="vx-row mb-6" v-if="!ProjectOnly">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Repository url:</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input class="w-full" v-model="newGitInfo.gitUrl" />
            </div>
          </div>
          <div class="vx-row mb-6" v-if="!ProjectOnly">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Username</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full" v-if="!ProjectOnly">
              <vs-input class="w-full" type="text" v-model="newGitInfo.gitUser" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Tags:</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <RelatedItemsDropdown @update:selectedItems="tagsUpdated" :selectedItems="newGitInfo.RelatedTags"
                RelatedItemsType="DataModel.TCVelik.Taxonomy.TCTag"
                RelatedParentType="DataModel.TCVelik.Project.TCProject" :RelatedParentId="newGitInfo.Id"
                typeName="DataModel.TCVelik.Project.TCProject" :GetItemsPromise="tagsService.getTags"
                :commitItemsPromise="tagsService.commitTags"></RelatedItemsDropdown>
            </div>
          </div>
          <div class="vx-row mb-6" v-if="!ProjectOnly">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Password</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input class="w-full" type="password" v-model="newGitInfo.gitPassword" />
            </div>
          </div>
          <div class="vx-row mb-6" v-if="!ProjectOnly">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Default branch</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input class="w-full" type="text" v-model="newGitInfo.defaultBranch" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Slug</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input class="w-full" v-model="newGitInfo.projectSlug" />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button class="mr-3 mb-2" @click="cloneProject">Submit</vs-button>
              <vs-button color="warning" type="border" class="mb-2" @click="
        input1 = input2 = input3 = input4 = input4 = '';
      check1 = false;
      ">Reset</vs-button>
            </div>
          </div>
        </div>
        <div v-if="isClonning">
          <h2>Clonning project</h2>
          <br />
          <span style="font-size: 10px">{{ this.clonningMessage }}</span>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import ProjectsService from "@/projects/projectsService.js";
import TCVelikClient from "@/TCVelikClient/TCVelikClient.js";
import RelatedItemsDropdown from "@/views/components/extra-components/RelatedItems/RelatedItemsDropdown.vue";
import TagsService from "@/tags/tagsService.js";

export default {
  data() {
    return {
      newGitInfo: {
        gitUrl: null,
        gitUser: null,
        gitPass: null,
        projectSlug: null,
        defaultBranch: "master",
        RelatedTags: [],
      },
      isClonning: false,
      tagsService: TagsService,
    }
  },
  mounted() {
    this.isClonning = false;
  },
  methods: {
    cloneProject() {
      var payLoad = {
        ProjectInfo: {
          GitUrl: this.newGitInfo.gitUrl,
          Slug: this.newGitInfo.projectSlug,
          Title: this.newGitInfo.Title,
          ProjectName: this.newGitInfo.Title
        },
        CloneInfo: {
          accountId: TCVelikClient.getSelectedAccount().Id,
          repositoryUrl: this.newGitInfo.gitUrl,
          username: this.newGitInfo.gitUser,
          password: this.newGitInfo.gitPassword,
          defaultBranch: this.newGitInfo.defaultBranch,
        },
        AccountId: TCVelikClient.getSelectedAccount().Id,
        NoGit: this.ProjectOnly
      };

      var instance = this;
      instance.isClonning = true;
      instance.clonningMessage = "Prepairing to clone ...";

      ProjectsService.cloneProject(payLoad).then(function (response) {
        if (response.data.IsError) {
          instance.$vs.notify({
            title: "Error",
            text: response.data.GeneralError
              ? response.data.GeneralError
              : "Error clonning the project. Check log for details.",
            color: "danger",
            iconPack: "feather",
            icon: "icon-check",
            time: 40000,
            fixed: true,
            // time: 80000
          });
        } else {
          instance.$vs.notify({
            title: "Success",
            text: instance.ProjectOnly ? "Project is done" : "Project is being cloned, you will be notified on success.",
            color: "success",
            iconPack: "feather",
            icon: "icon-check",
            time: 15000,
          });
        }
        instance.isClonning = false;
        if (instance.ProjectOnly) {
          window.location.reload();
        }
      });
    },
    tagsUpdated(newVal) {
      this.$set(this.newGitInfo, "RelatedTags", newVal);
    },
  },
  props: ["ProjectOnly", "PopupTitle"],
  components: {
    ProjectsService,
    RelatedItemsDropdown,
  },
};
</script>
